import styled from 'styled-components';

import { ButtonIcon, ButtonPrimary, H4Regular } from '@comeon/ui';
import { Modal } from '../../../../modal/modal-old';
import Portal from '../../../components/sportsbook-portal';
import LoadingSpinner from '../../components/sportsbook-loading-spinner';
import breakpoint from '../../../../../utils/style-utils';
import Icon, { ICON_CLOSE } from '../../../../icon';
import { Bet } from '../../api/betting-service/betting-service-types';
import ShareBetModalCard from './sportsbook-share-bet-modal-card';
import { Translation } from '../../../../translation/types';
import ShareBetModalTextKeys from './sportsbook-share-bet-modal-text-keys';
import React from 'react';

const Wrapper = styled.div`
	margin: 0;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: calc(100% - 48px);
	height: calc(100% - 48px);

	background-color: var(--sportsbook-bg-primary);
	border-radius: 12px;
	filter: drop-shadow(5px 10px 25px rgba(0, 0, 0, 0.15));

	display: flex;
	flex-direction: column;

	${breakpoint.lg`
		height: auto;
		max-height: calc(100% - 48px);;
		max-width: 345px;
	`}
`;

// added due to 888 franchise not having --base-11 variable
const StyledModal = styled(Modal)`
	background-color: rgba(var(--modal-wrapper-dark-bg, var(--base-11)), 0.85);
`;

const Header = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 10px;
	border-bottom: 1px solid var(--sportsbook-border-primary);
	flex: 0 0 auto;
`;
const HeaderLabel = styled(H4Regular)`
	padding-left: 30px;
	text-align: center;
	flex: 1 1 auto;
`;
const CloseIcon = styled(Icon).attrs({ type: ICON_CLOSE, height: 30, width: 30 })`
	fill: var(--sportsbook-text-main);
`;
const CloseButton = styled(ButtonIcon)`
	flex: 0 0 auto;
`;

const Body = styled.div`
	flex: 1 1 auto;
	position: relative;
	padding: 20px;
	overflow-y: auto;
	overflow-x: hidden;
`;

const LoadingSpinnerWrapper = styled.div`
	display: flex;
	height: 100%;
	width: 100%;
	z-index: 1;
	align-items: center;
	justify-content: center;
	background-color: var(--sportsbook-bg-primary);

	${breakpoint.lg`
		min-height: 300px;
	`}
`;

const StyledLoadingSpinner = styled(LoadingSpinner)`
	color: var(--sportsbook-text-main);
`;

const ShareButton = styled(ButtonPrimary)`
	font: var(--caption-bold);
	padding: 10px;
	border-radius: 6px;
	margin-top: 20px;
	background-color: var(--sportsbook-button-primary-alternative-bg, var(--button-primary-bg));
`;

type ShareBetModalProps = {
	translations: Translation;
	bet?: Bet;
	isLoading: boolean;
	cardRef: React.RefObject<HTMLDivElement | null>;
	onClose: () => void;
	onShare: () => void;
};

const ShareBetModal: React.FC<ShareBetModalProps> = ({ translations, bet, isLoading, cardRef, onClose, onShare }) => {
	return (
		<Portal>
			<StyledModal show blurBg regOnly>
				<Wrapper>
					<Header>
						<HeaderLabel>{translations[ShareBetModalTextKeys.SHARE_MODAL_HEADER_LABEL]}</HeaderLabel>
						<CloseButton onClick={onClose}>
							<CloseIcon type={ICON_CLOSE} />
						</CloseButton>
					</Header>
					<Body>
						{isLoading && (
							<LoadingSpinnerWrapper>
								<StyledLoadingSpinner />
							</LoadingSpinnerWrapper>
						)}
						{!isLoading && !!bet && (
							<>
								<ShareBetModalCard translations={translations} bet={bet} cardRef={cardRef} />
								<ShareButton onClick={onShare}>
									{translations[ShareBetModalTextKeys.SHARE_MODAL_BUTTON_LABEL]}
								</ShareButton>
							</>
						)}
					</Body>
				</Wrapper>
			</StyledModal>
		</Portal>
	);
};
export default ShareBetModal;
